import ResumeBriefSummary from "./ResumeBriefSummmary";

export default ResumeBriefSummary;
